module.exports = __webpack_public_path__ + "img/emoticon-csat-5-off.293b36b1.svg";